import { Formik } from "formik";
import { Grid } from "@mui/material";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import { useComponent } from "../../../hooks";
import pages from "../../../constants/pages";
import { objectFromFormData, schema } from "./actionObject";
import { ButtonFooter, ComponentHeader, Paper } from "../../../components";

export default function Form({
  fields,
  setFormData,
  actionType,
  editState,
  setEditState,
  formData,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { axios, alert } = useComponent();

  const [temp, setTemp] = useState("");
  const { activeBot } = useSelector((state) => state.memberDetails);

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validateOnMount
      validationSchema={schema(temp)}
      onSubmit={(formData, { setSubmitting }) => {
        let url = "/workflow/action/" + activeBot.ID;
        if (formData.actionID) {
          url =
            "/workflow/action/" +
            activeBot.ID +
            "?action_id=" +
            formData.actionID;
        }
        axios({
          url: url,
          method: "POST",
          data: objectFromFormData(formData),
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            if (formData.actionID) {
              setEditState(false);
            } else {
              navigate(pages.actionDetailsPage.route + response.data.action_id);
            }
            dispatch(alert.success(response.message.displayMessage));
          }
          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <Fragment>
          <Paper>
            <Grid item xs={12}>
              <ComponentHeader
                title="Action Details"
                subtitle="Action details"
              />
            </Grid>

            <FormDisplay
              fields={fields}
              setTemp={setTemp}
              actionType={actionType}
              editState={editState}
              formikProps={formikProps}
            />
          </Paper>

          <ButtonFooter
            ID={formikProps.values?.actionID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Fragment>
      )}
    </Formik>
  );
}
